/**
 * Maps raw technical error messages (Supabase, network, etc.) to
 * user-friendly French strings. Call this before any toast.error().
 */

const ERROR_MAP: Array<[RegExp | string, string]> = [
  // Auth — Supabase
  ['email_not_confirmed', 'Veuillez confirmer votre email avant de vous connecter.'],
  ['Email not confirmed', 'Veuillez confirmer votre email avant de vous connecter.'],
  ['Invalid login credentials', 'Email ou mot de passe incorrect.'],
  ['User already registered', 'Un compte existe déjà avec cet email.'],
  ['Email already exists', 'Un compte existe déjà avec cet email.'],
  ['Password should be at least', 'Le mot de passe doit contenir au moins 6 caractères.'],
  ['Email rate limit exceeded', 'Trop de tentatives. Réessayez dans quelques minutes.'],
  ['Invalid email', 'Adresse email invalide.'],
  ['signup_disabled', 'Les inscriptions sont temporairement désactivées.'],
  ['over_email_send_rate_limit', 'Trop d\'emails envoyés. Patientez avant de réessayer.'],
  ['Token has expired', 'Le lien a expiré. Demandez un nouveau lien.'],
  ['invalid_grant', 'Session expirée. Reconnectez-vous.'],
  ['JWT expired', 'Session expirée. Reconnectez-vous.'],
  ['not authenticated', 'Vous devez être connecté pour effectuer cette action.'],
  ['Unauthorized', 'Accès non autorisé.'],

  // Network
  [/fetch/i, 'Erreur de connexion. Vérifiez votre réseau.'],
  ['Failed to fetch', 'Erreur de connexion. Vérifiez votre réseau.'],
  ['NetworkError', 'Erreur réseau. Vérifiez votre connexion internet.'],
  ['net::ERR_', 'Erreur de connexion au serveur.'],

  // Storage
  ['storage/object-too-large', 'Fichier trop volumineux.'],
  ['The object is too large', 'Fichier trop volumineux.'],
  ['exceeded quota', 'Espace de stockage insuffisant.'],
  ['INVALID_MIME_TYPE', 'Type de fichier non autorisé.'],

  // Supabase generic
  ['PGRST116', 'Données introuvables.'],
  ['23505', 'Cet enregistrement existe déjà.'],
  ['23503', 'Impossible de supprimer — des données associées existent.'],
  ['42501', 'Permissions insuffisantes.'],

  // GPS / edge functions
  ['RATE_LIMIT_EXCEEDED', 'Trop de requêtes. Attendez un moment avant de réessayer.'],
  ['GPS_API_ERROR', 'Impossible de contacter le tracker GPS.'],
];

export function formatError(error: unknown): string {
  const message = errorToString(error);

  for (const [pattern, friendly] of ERROR_MAP) {
    if (typeof pattern === 'string') {
      if (message.includes(pattern)) return friendly;
    } else {
      if (pattern.test(message)) return friendly;
    }
  }

  // Last resort: return message only if it looks user-safe (no stack traces, no codes)
  if (message && message.length < 200 && !message.includes('at ') && !message.includes('\n')) {
    return message;
  }

  return 'Une erreur inattendue s\'est produite. Veuillez réessayer.';
}

function errorToString(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const e = error as Record<string, unknown>;
    if (typeof e.message === 'string') return e.message;
    if (typeof e.error === 'string') return e.error;
    if (typeof e.error_description === 'string') return e.error_description;
  }
  return String(error);
}
